import React, { useEffect, useState } from "react";
import CircularBar from "../../../components/chart-bars/CircularBar.jsx";
import "../../../styles/StoreBrowserIn.css";
import Report from "./Report.jsx";
import Proof from "./Proof.jsx";
import { Link, useLocation, useParams } from "react-router-dom";
import ScrollDown from "../../../components/ScrollDown.jsx";
import BreadCrumbLayout from "../../../components/common/BreadCrumbLayout.jsx";
import { Outlet } from "react-router-dom";
import { base_url } from "../../../utils/apiConfig.js";
import { Spin } from "antd";
import Trends from "./Trends.jsx";

const StoreBrowserIn = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { storeId, tabName } = useParams();
  const location = useLocation();
  const [data, setData] = useState(location.state?.storeData || null);
  const [tabData, setTabData] = useState(tabName || "trends");
  const [loading, setLoading] = useState(!location.state?.storeData);

  useEffect(() => {
    if (!data && storeId) {
      const token = localStorage.getItem("authToken");
      setLoading(true);
      fetch(
        `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/store/${storeId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      )
        .then((res) => res.json())
        .then((fetchedData) => setData(fetchedData))
        .catch((err) => console.log("Error fetching store data", err))
        .finally(() => setLoading(false));
    }
  }, [storeId, data]);

  useEffect(() => {
    if (tabName) {
      setTabData(tabName);
    }
  }, [tabName]);

  if (loading || !data) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
        <Spin size="large" />
      </div>
    );
  }
  const score = data.get_total_percentage?.score || 0;
  const getScoreTextColor = (scoreText) => {
    if (scoreText === "Bad" || scoreText === "Poor") return "#9d0000";
    if (scoreText === "Average") return "#dbaf00";
    return "#00a61f";
  };

  const scoreText =
    score >= 95
      ? "Excellent"
      : score >= 85
        ? "Good"
        : score >= 75
          ? "Average"
          : "Poor";
  const message = (
    <>
      Your Store Score Is{" "}
      <span style={{ color: getScoreTextColor(scoreText) }}>{scoreText}</span>
    </>
  );

  return (
    <div className="px-4">
      <div className="inMain">
        <div className="audit-first no-print"
          style={{ paddingTop: 0, margin: "1rem 0 0.5rem 0", width:"auto" }}
        >
          <div className="rbar px-3 text-start d-flex align-items-center">
            <Link to="/storebrowser" style={{ marginTop: "0px" }}>Store Browser</Link>
            <BreadCrumbLayout />
          </div>
        </div>
        <div className="hero-first mx-auto row py-2 d-flex justify-content-between">
          <div className="col-md-8">
            <div className="overall d-flex align-items-center gap-2">
              <p className="my-3">Overall Score</p>
              <div className="score-per">
                <p className="ms-1">
                  {/* {storeData.get_total_percentage?.score || "N/A"}% */}
                  {data.get_total_percentage?.score || "N/A"}%
                </p>
              </div>
            </div>
            <div className="audit-details mt-2 d-flex">
              <p className="ms-2">Store Details</p>
            </div>
            <div className="store-table d-flex mt-4 ">
              <div className="table-right">
                <table>
                  <tbody>
                    <tr>
                      <td className="leftText1">
                        <strong>Store Name</strong>
                      </td>
                      <td className="rightText1">{data?.name}</td>
                    </tr>
                    <tr>
                      <td className="leftText1">
                        <strong>City</strong>
                      </td>
                      <td className="rightText1">{data?.city?.name}</td>
                    </tr>
                    <tr>
                      <td className="leftText1">
                        <strong>Store Address</strong>
                      </td>
                      <td className="rightText1">{data?.address}</td>
                    </tr>
                    <tr>
                      <td className="leftText1">
                        <strong>Store</strong>
                      </td>
                      <td className="rightText1">{data?.city?.state}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="hero-right col-md-3 me-3 meter d-flex flex-column align-items-center justify-content-center">
            <p className="overallPara">Overall Store Score</p>
            <CircularBar storeData={data} />
            <div className="store-score d-flex justify-content-center align-items-center flex-column">
              <p className="scorePara">{message}</p>
              <div className="stats">
                <p className="m-0">What this statistics mean?</p>
              </div>
              <div className="grades-div d-flex flex-wrap gap-2 mt-3">
                <div
                  style={{ width: "55px" }}
                  className="stats-mean d-flex flex-column align-items-center justify-content-center"
                >
                  <p className="grade m-1">Excellent</p>
                  <p className="percent m-0">95% to above</p>
                  <div
                    style={{
                      width: "41px",
                      height: "8px",
                      borderRadius: "10px",
                      backgroundColor: "#C1FF99",
                    }}
                    className="mt-1 stats-div"
                  ></div>
                </div>
                <div className="stats-mean d-flex flex-column align-items-center justify-content-center">
                  <p className="grade m-1">Good</p>
                  <p className="percent m-0">85% to 94%</p>
                  <div
                    style={{
                      width: "41px",
                      height: "8px",
                      borderRadius: "10px",
                      backgroundColor: "#EAFF99",
                    }}
                    className="mt-1 stats-div"
                  ></div>
                </div>
                <div className="stats-mean d-flex flex-column align-items-center justify-content-center">
                  <p className="grade m-1">Average</p>
                  <p className="percent m-0">75% to 84%</p>
                  <div
                    style={{
                      width: "41px",
                      height: "8px",
                      borderRadius: "10px",
                      backgroundColor: "#FFFF99",
                    }}
                    className="mt-1 stats-div"
                  ></div>
                </div>
                <div className="stats-mean d-flex flex-column align-items-center justify-content-center">
                  <p className="grade m-1">Poor</p>
                  <p className="percent m-0">0% to 74%</p>
                  <div
                    style={{
                      width: "41px",
                      height: "8px",
                      borderRadius: "10px",
                      backgroundColor: "#FFC299",
                    }}
                    className="mt-1 stats-div"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-container">
          <div
            onClick={() => {
              setTabData("trends");
            }}
            className={`trends df ${tabData === "trends" ? "active" : ""}`}
          >
            <i className="bi bi-bar-chart-fill"></i>
            <p className="textOfTab">Trends</p>
          </div>
          <div
            onClick={() => {
              setTabData("reports");
            }}
            className={`reports df ${tabData === "reports" ? "active" : ""}`}
          >
            <i className="bi bi-calendar-minus"></i>
            <p className="textOfTab">Reports</p>
          </div>
          <div
            onClick={() => {
              setTabData("proof");
            }}
            className={`proof df ${tabData === "proof" ? "active" : ""}`}
          >
            <i className="bi bi-arrow-left-right"></i>
            <p className="textOfTab">Proof Comparison</p>
          </div>
        </div>
        <div className="trp">
          {tabData === "trends" ? (
            <Trends storeData={data} />
          ) : tabData === "reports" ? (
            <Report storeData={data} />
          ) : (
            <Proof storeData={data} />
          )}
        </div>
        <Outlet />
      </div>
      <ScrollDown />
    </div>
  );
};

export default StoreBrowserIn;
